var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.65,2h-.4V4h.4A2.36,2.36,0,0,1,20,6.36v4.47H15.71a1,1,0,0,0-1,1c0,2.2-1.13,2.2-1.5,2.2H10.79c-.37,0-1.49,0-1.5-2.2a1,1,0,0,0-1-1H4V6.36A2.36,2.36,0,0,1,6.35,4h.4V2h-.4A4.36,4.36,0,0,0,2,6.36V17.64A4.36,4.36,0,0,0,6.35,22h11.3A4.36,4.36,0,0,0,22,17.64V6.36A4.36,4.36,0,0,0,17.65,2ZM20,12.83v4.81A2.36,2.36,0,0,1,17.65,20H6.35A2.36,2.36,0,0,1,4,17.64V12.83H7.37A3.36,3.36,0,0,0,10.79,16h2.42a3.36,3.36,0,0,0,3.42-3.19Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.f0c6c9b0e2563e3d5da46218adfa8790.svg";
export { ForwardRef as ReactComponent };